// entry/index file

// make it compatible with browserify's umd wrapper
module.exports = require('./mpegts.js').default;
